var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 39,
    viewBox: "0 0 78 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 0H46.8C44.6461 0 42.9 1.74609 42.9 3.9C42.9 6.05391 44.6461 7.8 46.8 7.8H58.5C64.935 7.8 70.2 13.065 70.2 19.5C70.2 25.935 64.935 31.2 58.5 31.2H46.8C44.6461 31.2 42.9 32.9461 42.9 35.1C42.9 37.2539 44.6461 39 46.8 39H58.5C69.264 39 78 30.264 78 19.5C78 8.736 69.264 0 58.5 0ZM35.1 35.1C35.1 32.9461 33.3539 31.2 31.2 31.2H19.5C13.065 31.2 7.8 25.935 7.8 19.5C7.8 13.065 13.065 7.8 19.5 7.8H31.2C33.3539 7.8 35.1 6.05391 35.1 3.9C35.1 1.74609 33.3539 0 31.2 0H19.5C8.736 0 0 8.736 0 19.5C0 30.264 8.736 39 19.5 39H31.2C33.3539 39 35.1 37.2539 35.1 35.1ZM23.4 19.5C23.4 17.3461 25.1461 15.6 27.3 15.6H50.7C52.8539 15.6 54.6 17.3461 54.6 19.5C54.6 21.6539 52.8539 23.4 50.7 23.4H27.3C25.1461 23.4 23.4 21.6539 23.4 19.5Z",
    fill: "#F22E62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink4);
export default __webpack_public_path__ + "static/media/link4.c9fae31a4240e9f54ef16883a3bd482a.svg";
export { ForwardRef as ReactComponent };